export default __webpack_public_path__ + "static/media/bauhaus-dark-lg.5b4d9632.svg";